import { render, staticRenderFns } from "./CardModalToggleViewSize.vue?vue&type=template&id=6820b99e&scoped=true&"
import script from "./CardModalToggleViewSize.vue?vue&type=script&lang=ts&"
export * from "./CardModalToggleViewSize.vue?vue&type=script&lang=ts&"
import style0 from "./CardModalToggleViewSize.vue?vue&type=style&index=0&id=6820b99e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6820b99e",
  null
  
)

export default component.exports